import { api } from "./client";

export interface LegalAcceptanceStatus {
  needsAcceptance: boolean;
  pendingDocuments: {
    type: string;
    name: string;
    currentVersion: string;
  }[];
  acceptedDocuments: {
    type: string;
    name: string;
    version: string;
    acceptedAt: string;
  }[];
}

export function getLegalStatus() {
  return api.get<LegalAcceptanceStatus>("/legal/status");
}

export function acceptLegalDocuments(
  acceptances: {
    documentType: string;
    documentVersion: string;
  }[]
) {
  return api.post<{ success: boolean; message: string }>("/legal/accept", {
    acceptances,
  });
}

export function getBaaDownloadUrl() {
  return api.get<{ url: string }>("/legal/baa-download");
}
